<template>
  <div class="title-block">号車指定</div>
  <div class="nav-block">
    <nav>
      <ul>
        <li
          v-for="(car, index) in props.cars"
          :key="index"
          :value="car"
          :style="[car.saloon_only ? { display: 'none' } : '']"
        >
          <a
            :class="[
              selectedCar == car ? 'current' : '',
              car.is_exclusive ? 'disable' : '',
            ]"
            @click="selectCar(car)"
            >{{ car.number }}</a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingSelectBlockCarNumber",
  props: {
    cars: {
      type: Array,
      required: true,
    },
    selectedCar: {
      required: true,
    },
    selectedSeat: {
      required: true,
    },
    openConrifmDialog: {
      required: true,
    },
  },
  setup(props) {
    const selectedCar = useVModel(props, "selectedCar");
    const selectedSeat = useVModel(props, "selectedSeat");

    const selectCar = (car) => {
      if (selectedSeat.value.length > 0) {
        // 号車を切り替えると、選択中の座席をリセットする。
        // その旨を確認するダイアログを表示
        props.openConrifmDialog(car);
      } else {
        selectedCar.value = car;
        console.log("selectedCar :>> ", selectedCar);
      }
    };

    return {
      props,
      selectedCar,
      selectCar,
    };
  },
};
</script>
<style lang="scss" scoped>
.title-block {
  margin: 16px 6px 10px;
  font-size: 15px;
  text-align: left;
  line-height: 18px;
  color: #000000;
  font-weight: bold;
}
.nav-block {
  width: 100%;
}
.nav-block nav {
}
.nav-block nav ul {
  display: flex;
  margin: 0;
  padding: 0;
  width: 100%;
}
.nav-block nav ul li {
  list-style-type: none;
  flex: 1;
  margin: 0 1px 0 0;
  padding: 0;
  font-size: 13px;
  font-weight: bold;
}
.nav-block nav ul li:last-of-type {
  margin-right: 0;
}
.nav-block nav ul li a {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  text-decoration: none;
  background-color: #e0e0e0;
  color: #999999;
}
.nav-block nav ul li:first-of-type a {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.nav-block nav ul li:last-of-type a {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.nav-block nav ul li a.current {
  background-color: #ffb206;
  color: #ffffff;
}

.nav-block nav ul li a.disable {
  background-color: #828282;
  color: #999999;
  pointer-events: none;
}
</style>
